<button #button (click)="onClick()" [attr.title]="title" [attr.disabled]="getDisabled()" [style.height]="heightInPx" [style.width]="widthInPx">
    <svg-icon-sprite [src]="getIconSrc()" [classes]="getIconClass()" [width]="widthInPx" [height]="heightInPx"></svg-icon-sprite>
    <span class="sr-only">{{screenReaderText}}</span>
</button>
